<h3>Data exchange</h3>

<div class="workspace-content">
  <div class="app" *ngIf="psFormAccess$ | async">
    <div class="app-image" [routerLink]="['ua-ps-admin']">
      <img src="assets/app_customercareservicetracker.svg" />
    </div>
    <div class="app-name">Customer Care <br />Service Tracker</div>
  </div>
    <div class="app" *ngIf="premiumaccountinginputform$ | async">
    <div class="app-image" [routerLink]="['premium-accounting']">
      <img src="assets/premium-accounting.svg" />
    </div>
    <div class="app-name">Premium Accounting</div>
  </div>

  <div class="app" *ngIf="automationFormAccess$ | async">
    <div class="app-image" [routerLink]="['agent-automation']">
      <img src="assets/app_agentinsightautomationtracker.svg" />
    </div>
    <div class="app-name">
      Recruiting Pipeline <br />
      Data Collection
    </div>
  </div>

  <div class="app" *ngIf="worksiteAccess$ | async">
    <div class="app-image" [routerLink]="['worksite-tracker']">
      <img src="assets/app_lndworksitetracker.svg" />
    </div>
    <div class="app-name">Worksite Manual <br />Payments Log</div>
  </div>

  <div class="app" *ngIf="bankCompliance$ | async">
    <div class="app-image" [routerLink]="['bank-compliance']">
      <img src="assets/app_bank_compliance.png" />
    </div>
    <div class="app-name">Bank Compliance <br />Early Fraud Detection</div>
  </div>

  <div class="app" *ngIf="claimAuditLogsAccess$ | async">
    <div class="app-image" [routerLink]="['claim-audit-logs']">
      <img src="assets/app_claimauditlogs.svg" />
    </div>
    <div class="app-name">Claim Audit <br />Logs</div>
  </div>
  <div class="app" *ngIf="productionTask$ | async">
    <div class="app-image" [routerLink]="['production-task']">
      <img src="assets/prod-task.svg" />
    </div>
    <div class="app-name">
      Production Form <br />
      Task Log
    </div>
  </div>
  <div class="app" *ngIf="underwriting$ | async">
    <div class="app-image" [routerLink]="['underwriting']">
      <img src="assets/underwriting.svg" />
    </div>
    <div class="app-name">Underwriting</div>
  </div> 
  <div class="app" *ngIf="fhdhierarchy$ | async">
    <div class="app-image" [routerLink]="['fhd-hierarchy']">
      <img src="assets/fhdhierarchy.svg" />
    </div>
    <div class="app-name">FHD Hierarchy</div>
  </div>  
  <div class="app" *ngIf="fhdinputform$ | async">
    <div class="app-image" [routerLink]="['fhd-input-form']">
      <img src="assets/fhduserinputform.svg" />
    </div>
    <div class="app-name">FHD User InputForm</div>
  </div> 
  <div class="app" *ngIf="legalComplaints$ | async">
    <div class="app-image" [routerLink]="['legal-complaints']">
      <img src="assets/legal-complaints.svg" />
    </div>
    <div class="app-name">Legal Complaints</div>
  </div>
  <div class="app" *ngIf="legalexpense$ | async">
    <div class="app-image" [routerLink]="['legal-expense-invoice']">
      <img src="assets/legal_invoice_app_logo.svg" />
    </div>
    <div class="app-name">Legal Expense <br />Invoice Tracking</div>
  </div>
  <div class="app" *ngIf="outageTracker$ | async">
    <div class="app-image" [routerLink]="['outage-tracker']">
      <img src="assets/outage-tracker.svg" />
    </div>
    <div class="app-name">Outage Tracker</div>
  </div>
  <div class="app" *ngIf="investment$ | async">
    <div class="app-image" [routerLink]="['investments']">
      <img src="assets/form.png" />
    </div>
    <div class="app-name">Investment</div>
  </div>
  <div class="app" *ngIf="growthadjustmentsinputform$ | async">
    <div class="app-image" [routerLink]="['growth-adjustments']">
      <img src="assets/growthadjustmentsinputform.svg" />
    </div>
    <div class="app-name">Growth Adjustments</div>
  </div> 
  <div class="app" *ngIf="projectionspromotionsinputform$ | async">
    <div class="app-image" [routerLink]="['projections-promotions']">
      <img src="assets/promotionsprojections.svg" />
    </div>
    <div class="app-name">Projections Promotions</div>
  </div> 
</div>
<div class="loading-content" *ngIf="(hasAnyAccess$ | async) == false">
  <img class="loading-icon" src="assets/GlobeIQ_Icon.svg" />
  <span class="loading-text">No data exchange apps found</span>
</div>
